export const GET_SCHOOLS = "GET_SCHOOLS";
export const SET_SCHOOLS = "SET_SCHOOLS";
export const SUBMIT_SIGNUP = "SUBMIT_SIGNUP";
export const SET_SIGNUP_SUCCESS = "SET_SIGNUP_SUCCESS";
